import type { FC, SVGProps } from 'react'

import LogoImg from '../../../assets/img/logo.svg?react'

const LogoIcon: FC<SVGProps<SVGSVGElement> & { title?: string }> = (props) => {
  return <LogoImg {...props} width={36} height={36} />
}

export default LogoIcon
